/** Risultato dell'inserimento di un segnaposto: nuovo testo e posizione del cursore dopo di esso. */
export interface Insertion {
  value: string;
  caret: number;
}

/**
 * Inserisce `placeholder` al posto della selezione `[start, end)` di `text`. Se il campo non ha
 * una selezione valida il segnaposto va in coda, separato da uno spazio quando serve.
 */
export function insertPlaceholder(
  text: string,
  placeholder: string,
  start: number | null,
  end: number | null
): Insertion {
  if (start === null || end === null || start < 0 || end > text.length || start > end) {
    const separator = text.length === 0 || /\s$/.test(text) ? '' : ' ';
    const value = `${text}${separator}${placeholder}`;
    return { value, caret: value.length };
  }
  const value = `${text.slice(0, start)}${placeholder}${text.slice(end)}`;
  return { value, caret: start + placeholder.length };
}
